module.exports = __webpack_public_path__ + "static/SortAndSearch-d2e00fb0360ced3167613152b5e137d6.gif";